<app-title-payment [titleP]="Title"></app-title-payment>
<app-table-payments></app-table-payments>
<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(28,95,121,0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="color: white"> Cargando... </p>
</ngx-spinner>